// ----------------------------------------------------------------------

export default function useGetMessage({ message, participants, currentUserId }) {
  // Convert IDs to strings for comparison to handle number vs string mismatch
  const senderId = String(message.senderId);
  const currentId = String(currentUserId);

  const sender = participants.find((participant) => String(participant.id) === senderId);

  const senderDetails =
    senderId === currentId
      ? {
          type: 'me',
        }
      : {
          avatarUrl: sender?.avatarUrl,
          firstName: sender?.name?.split(' ')[0] || 'User',
        };

  const me = senderDetails.type === 'me';

  const hasImage = message.contentType === 'image';

  return {
    hasImage,
    me,
    senderDetails,
  };
}
